export const LOCAL_FILTER_FIELDS = [
    {
        label: "Item tax",
        type: "text",
        name: "itemTax",
    }
]